module.exports = __webpack_public_path__ + "img/android2icon1.e495c81d.png";